import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../../../consts/api";

export const useCloseSmartReader = () => {
  return useMutation((readerIdentifier) =>
    http.post(HTTP_ENDPOINTS.closeSmartReader(readerIdentifier)),
  );
};
